import React from 'react';
import { FirebaseAppProvider, FirestoreProvider } from 'reactfire';
import { firebaseConfig } from './utils/firebaseConfig';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import './App.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Dashboard from './pages/Dashboard';
import { useEmulators } from './utils/firebase';
import { InstaceContextProvider } from './context/InstanceContext';
import NotFound from './pages/NotFound';
import '@wix/design-system/styles.global.css';
import { initializeApp } from 'firebase/app';


const firebaseApp = initializeApp(firebaseConfig);
const firestore = getFirestore(firebaseApp);

if (useEmulators) {
  console.log('Connecting to emulators');
  connectFirestoreEmulator(firestore, 'localhost', 8080);
}

function ContentApp() {

  if (window.location.pathname === '/dashboard') {
    return <InstaceContextProvider><Dashboard /></InstaceContextProvider>
  }

  return <NotFound />
}

function App() {
  return <FirebaseAppProvider firebaseConfig={firebaseConfig}>

    <FirestoreProvider sdk={firestore}>
      <ContentApp />
    </FirestoreProvider>

  </FirebaseAppProvider>
}

export default App;